import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { API, formatError } from "@/api";
import axios from "axios";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    const token = localStorage.getItem("vbs_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/api/auth/me");
      setUser(data);
    } catch (e) {
      localStorage.removeItem("vbs_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("vbs_token", data.access_token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatError(e.response?.data?.detail) || e.message };
    }
  };

  const signupStripe = async (email, password, full_name) => {
    try {
      const { data } = await axios.post(`${API}/auth/register/stripe`, { email, password, full_name });
      localStorage.setItem("vbs_token", data.access_token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatError(e.response?.data?.detail) || e.message };
    }
  };

  const signup = async (email, password, full_name, license_code) => {
    try {
      const { data } = await axios.post(`${API}/auth/register`, { email, password, full_name, license_code });
      localStorage.setItem("vbs_token", data.access_token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatError(e.response?.data?.detail) || e.message };
    }
  };

  const logout = () => {
    localStorage.removeItem("vbs_token");
    localStorage.removeItem("vbs_anthropic_key");
    setUser(null);
  };

  const refresh = fetchMe;

  return (
    <AuthCtx.Provider value={{ user, loading, login, signup, signupStripe, logout, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}
